import React, { FC } from 'react';
import { Label, Upload } from '@silverfort/sf-components';

interface Props {
    label: string;
    mandatory?: boolean;
    labelClassName?: string;
    onRemove: VoidFunction;
    onUploadCertificate: (files: FileList | (File | null)[] | null) => void;
    isUploadingCertificate: boolean;
    isCompleted?: boolean;
    className?: string;
    fileName?: string;
}

const TokenUploadCertificateField: FC<Props> = ({
    label = '',
    mandatory = true,
    labelClassName = 'w-[235px] !h-10',
    isUploadingCertificate,
    onUploadCertificate,
    isCompleted = false,
    onRemove,
    className = 'h-[72px]',
    fileName
}) => {
    return (
        <div className="flex items-start gap-2">
            <Label text={label} mandatory={mandatory} className={labelClassName} />
            <Upload
                horizontal
                iconLayoutClassName="h-8 w-8"
                subtitle="Max file size up to 10 MB"
                onChange={onUploadCertificate}
                loading={isUploadingCertificate}
                completed={isCompleted}
                onRemove={onRemove}
                className={className}
                customTitle={fileName}
            />
        </div>
    );
};

export default TokenUploadCertificateField;
